import type { home as homeEn } from '../en/home';

export const home: typeof homeEn = {
  greeting: '¡Hola!',
  greetingWithName: (name: string) => `¡Hola, ${name}!`,

  prenatal: {
    checklistTitle: 'Preparativos',
    dueDateLabel: (date: string) => `Fecha probable de parto: ${date}`,
    noDueDate: 'Su bebé viene en camino.',
  },

  birthSheet: {
    when: '¿Cuándo nació el bebé?',
    nickname: 'Apodo del bebé (opcional)',
    nicknameHint: 'Con un apodo basta. La app no necesita el nombre legal.',
    weight: 'Peso al nacer (opcional)',
    lb: 'lb',
    oz: 'oz',
    grams: 'gramos',
  },

  visits: {
    title: 'Su plan de visitas',
    status: {
      upcoming: 'Próxima',
      due: 'Hora de reservar',
      scheduled: 'Reservada',
      past: 'Pasada',
    },
  },

  checkup: {
    inDays: (days: number) =>
      days === 0 ? 'Es hoy' : days === 1 ? 'Es mañana' : `Faltan ${days} días`,
  },

  today: {
    title: 'Hoy, de un vistazo',
    feeds: 'Tomas',
    wetDiapers: 'Pañales mojados',
    dirtyDiapers: 'Evacuaciones',
    ofMin: (n: number, min: number) => `${n} de ${min}`,
    lastFeed: (ago: string) => `Última toma: ${ago}`,
    empty: 'Todavía no hay registros hoy. Lo que agregue en la pestaña Registrar aparecerá aquí.',
  },

  nudge: {
    sinceLastFeed:
      'Han pasado unas horas desde la última toma registrada. Si su bebé muestra señales de hambre, puede ser un buen momento.',
    noFeedsYet: 'Cuando su bebé coma, regístrelo en Registrar y aquí verá cómo toma forma su día.',
    action: 'Ir a Registrar',
  },

  partner: {
    guideLink: 'Ver todos los consejos en la Guía',
  },
};
